import dispatcher from "../utilities/dispatcher";
import * as actionTypes from "./actions";
import Config from "../Config";
const StateFunction = {
  HandleOnChange: async (dispatch, element) => {
    dispatch({
      type: actionTypes.HANDLE_ON_CHANGE,
      data: element.target,
    });
  },
  HandleLoading: async (dispatch, element) => {
    dispatch({
      type: actionTypes.Handle_Loading,
      data: element,
    });
  },
  HandleOnChangeObject: async (dispatch, element, object) => {
    dispatch({
      type: actionTypes.HANDLE_ON_CHANGE_OBJECT,
      Name: element.target.name,
      value: element.target.value,
      obj: object,
    });
  },
  HandleSignupClear: async (dispatch) => {
    dispatch({
      type: actionTypes.Handle_Signup_Clear,
    });
  },
  TwoWayFactorData: async (dispatch, EmpId) => {
    dispatcher
      .call({
        url:
          Config.yozyme +
          Config.endpoint.postgre.employee_twofactor_auth +
          `?EmpId=eq.${EmpId}`,
        method: "get",
      })
      .then((res) =>
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "twofacoteruserdata",
            value: res,
          },
        })
      )
      .catch((err) => console.error(err));
  },
  ConfirmAlert: async (dispatch, open, header, msg) => {
    StateFunction.HandleOnChange(dispatch, {
      target: {
        name: "alert",
        value: open,
      },
    });
    StateFunction.HandleOnChange(dispatch, {
      target: {
        name: "alertmsg",
        value: msg,
      },
    });
    StateFunction.HandleOnChange(dispatch, {
      target: {
        name: "alertheadermsg",
        value: header,
      },
    });
  },
  ProjeectMappingApicall: async (dispatch, state) => {
    dispatcher
      .call({
        url: Config.yozyme + Config.endpoint.postgre.projectrallocation,
        method: "get",
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "ProjMapping",
            value: res,
          },
        });
      });
  },
  OrginfoDetailsApiCall: async (dispatch) => {
    dispatcher
      .call({
        url: Config.postgre_host + Config.endpoint.express.organizationdetails,
        method: "get",
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "OrgTable",
            value: res,
          },
        });
      });
  },
  ProductList: async (dispatch) => {
    dispatcher
      .call({
        url: Config.postgre_host + Config.endpoint.express.Product_master,
        method: "get",
      })
      .then((res) => {
        let list = res.map((e) => ({
          value: e.ProductId,
          label: e.ProductName,
          name: e.ProductId,
          Domain: e.Domain,
          code: e.ProductCode,
          IncludedProducts: e.IncludedProducts,
        }));
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "ProductList",
            value: list,
          },
        });
      });
  },
  EnquiryDetailsApiCall: async (dispatch) => {
    try {
      const response = await dispatcher.call({
        url: Config.express_host + Config.endpoint.express.enquiryget,
        method: "get",
      });
  
      if (!response || !response.data) {
        console.error("Invalid response received:", response);
        return;
      }
  
      let list = response.data;
  
      // Ensure list is an array before filtering
      if (!Array.isArray(list)) {
        console.error("Unexpected data format:", list);
        return;
      }
  
      StateFunction.HandleOnChange(dispatch, {
        target: {
          name: "EnquiryList",
          value: list.filter(
            (u) =>
              u.IsApproved !== "Y" &&
              u.IsApproved !== "R" &&
              u.Firstname != null
          ),
        },
      });
  
      StateFunction.HandleOnChange(dispatch, {
        target: {
          name: "EnquiryListReject",
          value: list.filter(
            (u) => u.IsApproved !== null && u.Firstname != null
          ),
        },
      });
  
    } catch (error) {
      console.error("API call failed:", error);
    }
  },
  
  // EnquiryDetailsApiCall: async (dispatch) => {
  //   dispatcher
  //     .call({
  //       url: Config.express_host + Config.endpoint.express.enquiryget,
  //       method: "get",
  //     })
  //     .then((res) => {
  //       let list = res.data;
  //       StateFunction.HandleOnChange(dispatch, {
  //         target: {
  //           name: "EnquiryList",
  //           value: list?.filter(
  //             (u) =>
  //               u.IsApproved !== "Y" &&
  //               u.IsApproved !== "R" &&
  //               u.Firstname != null
  //           ),
  //         },
  //       });
  //       StateFunction.HandleOnChange(dispatch, {
  //         target: {
  //           name: "EnquiryListReject",
  //           value: list.filter(
  //             (u) => u.IsApproved !== null && u.Firstname != null
  //           ),
  //         },
  //       });
  //     });
  // },
  RolemasterApiCall: async (dispatch) => {
    dispatcher
      .call({
        url: Config.postgre_host + Config.endpoint.express.Role_master,
        method: "get",
      })
      .then((res) => {
        let list = res;
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "Rolemaster",
            value: list,
          },
        });
      });
  },

  PlanmasterApiCall: async (dispatch) => {
    console.log("called");
    dispatcher
      .call({
        url: Config.postgre_host + Config.endpoint.express.plan_master,
        method: "get",
      })
      .then((res) => {
        let list = res;
        console.log("called", res);

        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "Planmaster",
            value: list,
          },
        });
      });
  },
  ProductmasterApiCall: async (dispatch) => {
    dispatcher
      .call({
        url: Config.postgre_host + Config.endpoint.express.Product_master,
        method: "get",
      })
      .then((res) => {
        let list = res;
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "Productmaster",
            value: list,
          },
        });
      });
  },
  SubscriptionLicense: async (dispatch, state) => {
    console.log(state,"stateclientif");
    
    dispatcher
      .call({
        url:
          Config.postgre_host +
          Config.endpoint.express.subscriptiondetails +
          "?ClientId=eq." +
          state.ClientId,
        method: "get",
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "SubscriptionDetails",
            value: res,
          },
        });
      });
  },
  SubscriptionLicensePromote: async (dispatch, ClientId) => {
    dispatcher
      .call({
        url:
          Config.postgre_host +
          Config.endpoint.express.subscriptiondetails +
          "?ClientId=eq." +
          ClientId,
        method: "get",
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "SubscriptionDetailsPromote",
            value: res,
          },
        });
      });
  },
  SubscriptionLicenseAll: async (dispatch, state) => {
    dispatcher
      .call({
        url: Config.postgre_host + Config.endpoint.express.subscriptiondetails,
        //  +
        // "?IsActive=eq.",

        method: "get",
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "Subscriptionlicenseall",
            value: res,
          },
        });
      });
  },
  SubscriptionDetailsApiCall: async (dispatch, state) => {
    dispatcher
      .call({
        url:
          Config.yozyme +
          Config.endpoint.express.Subuser +
          "?ClientId=eq." +
          state.ClientId,
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "SubscriptionUserDetails",
            value: res,
          },
        });
      });
  },
  SubscriptionDetailsApiCallalluser: async (dispatch, state) => {
    dispatcher
      .call({
        url: Config.yozyme + Config.endpoint.express.Subuser,
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "SubscriptionUserDetailsall",
            value: res,
          },
        });
      });
  },
  OrgSettings: async (dispatch, state) => {
    dispatcher
      .call({
        url:
          Config.postgre_host +
          Config.endpoint.express.Orgapprovalsettings +
          "?ClientId=eq." +
          state.ClientId,
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "OrgApprovesetting",
            value: res,
          },
        });
      });
  },
  SuperorgSettings: async (dispatch, clientid) => {
    dispatcher
      .call({
        url:
          Config.postgre_host +
          Config.endpoint.express.Orgapprovalsettings +
          "?ClientId=eq." +
          clientid,
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "SuperorgApprovesetting",
            value: res,
          },
        });
      });
  },
  Superitsmgrp: async (dispatch, state) => {
    dispatcher
      .call({
        url:
          Config.yozyme +
          Config.endpoint.express.Itsmgroup +
          "?ClientId=eq." +
          state.ClientId,
        // method: "get",
      })
      .then((res) => {
        // let data = res;
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "Superitsmgrp",
            value: res,
          },
        });
      });
  },
  OnboardedUserlist: async (dispatch, state) => {
    dispatcher
      .call({
        url:
          Config.yozyme +
          Config.endpoint.express.organizationdetails +
          "?select=ClientCompanyName,DateOnboarded,ClientId,UsersList:subscription_client_users(ClientUserId,UserFirstname,OfficialEmail,Phone,UUID),License:subscription_client_license_details(ProductDetails,PlanDetails,ValidTill,IsActive)&ClientId=eq." +
          state.ClientId,
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "OnboardedUserlist",
            value: res,
          },
        });
      });
  },
  Superitsmgrporg: async (dispatch, clientid) => {
    dispatcher
      .call({
        url:
          Config.yozyme +
          Config.endpoint.express.Itsmgroup +
          "?ClientId=eq." +
          clientid,
        // method: "get",
      })
      .then((res) => {
        // let data = res;
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "Superitsmgrporg",
            value: res,
          },
        });
      });
  },
  Groupmaping: async (dispatch, state) => {
    dispatcher
      .call({
        url:
          Config.yozyme +
          Config.endpoint.express.groupmap +
          "?ClientId=eq." +
          state.ClientId,
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "Groupmaping",
            value: res,
          },
        });
      });
  },
  OrgGroupmaping: async (dispatch, clientid) => {
    dispatcher
      .call({
        url:
          Config.yozyme +
          Config.endpoint.express.groupmap +
          "?ClientId=eq." +
          clientid,
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "OrgGroupmaping",
            value: res,
          },
        });
      });
  },
  OrgprojectMaster: async (dispatch, state) => {
    dispatcher
      .call({
        url:
          Config.yozyme +
          Config.endpoint.express.projectmaster +
          "?select=ProjectId,ProjectShortCode,ProjectName,ClientId,Allocations:agilesaas_project_mapping(ProjectCode,IsCurrent,TeamMemberId,AllocPercentage,ProjectEndDate,ProjectRole),agilesaas_issue_details(ProjectId,IssueId),agilesaas_releases(ProjectId,ReleaseId)&ClientId=eq." +
          state.ClientId,
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "OrgprojectMaster",
            value: res,
          },
        });
      });
  },
  ProjectMaster: async (dispatch, clientid) => {
    dispatcher
      .call({
        url:
          Config.yozyme +
          Config.endpoint.express.projectmaster +
          "?select=ProjectId,ProjectShortCode,ProjectName,ClientId,Allocations:agilesaas_project_mapping(ProjectCode,IsCurrent,TeamMemberId,AllocPercentage,ProjectEndDate,ProjectRole),agilesaas_issue_details(ProjectId,IssueId),agilesaas_releases(ProjectId,ReleaseId)&ClientId=eq." +
          clientid,
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "ProjectMaster",
            value: res,
          },
        });
      });
  },
  UserSessions: async (dispatch, state) => {
    dispatcher
      .call({
        url:
          Config.yozyme + "/subscription_user_session_audit?OrgDetails->>ClientId=eq." +
          state.ClientId,
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "UserSessions",
            value: res,
          },
        });
      });
  },
  OrgUserSessions: async (dispatch, clientid) => {
    dispatcher
      .call({
        url:
          Config.yozyme + "/subscription_user_session_audit?OrgDetails->>ClientId=eq." +
          clientid,
      })
      .then((res) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "OrgUserSessions",
            value: res,
          },
        });
      });
  },
  UserRoleMapdetialsApiCall: async (dispatch, state) => {
    dispatcher
      .call({
        url:
          Config.yozyme +
          Config.endpoint.express.Userrole +
          "?ClientId=eq." +
          state.ClientId,
        method: "get",
      })
      .then((data) => {
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "UserRoleMapProductDetails",
            value: data,
          },
        });
      });
  },
  HandlecloseEnquiryModel: async (dispatch) => {
    let data = {
      AdminDepartment: "",
      AdminEmail: "",
      AdminPhone: "",
      AdminLastname: "",
      AdminFirstname: "",
      ClientCompanyName: "",
      ClientAddress1: "",
      ClientAddress2: "",
      ClientCity: "",
      ClientCountry: "",
      ClientState: "",
      ClientPincode: "",
      ClientCountryCode: "",
      ClientContactName: "",
      ClientDesignation: "",
      CurrencyCode: "",
      ClientType: "",
      NatureOfBusiness: "",
      BusinessVertical: "",
      ClientRevenueInUSD: "",
      ContactName: "",
      ContactDesignation: "",
      ContactEmail: "",
      ContactPhone: "",
      EnquiryModel: false,
      Product: null,
    };
    StateFunction.HandleOnChange(dispatch, {
      target: {
        name: "EnquiryOrgdetails",
        value: data,
      },
    });
    StateFunction.HandleOnChange(dispatch, {
      target: {
        name: "EnquiryModel",
        value: false,
      },
    });
    StateFunction.HandleOnChange(dispatch, {
      target: {
        name: "buttonclick",
        value: true,
      },
    });
  },

  Orguserlistdata: async (dispatch, clientid) => {
    dispatcher
      .call({
        url:
          Config.postgre_host +
          Config.endpoint.express.Userrole +
          "?ClientId=eq." +
          clientid,
        // + "&UserDetails->>Firstname=neq." + Name,
        method: "get",
      })
      .then((res) =>
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "fulluserslist",
            value: res,
          },
        })
      )
      .catch((err) => console.error(err));

    dispatcher
      .call({
        url:
          Config.postgre_host +
          Config.endpoint.express.Subuser +
          "?ClientId=eq." +
          clientid +
          "&IsActive=eq.Y",
        method: "get",
      })
      .then((res) =>
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "activeuserslist",
            value: res,
          },
        })
      )
      .catch((err) => console.error(err));

    dispatcher
      .call({
        url:
          Config.postgre_host +
          Config.endpoint.express.Subuser +
          "?ClientId=eq." +
          clientid,
        method: "get",
      })
      .then((res) =>
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "orgactiveuserslist",
            value: res,
          },
        })
      )
      .catch((err) => console.error(err));
  },

  UserRolemaping: async (dispatch, pfname) => {
    dispatcher
      .call({
        url:
          Config.postgre_host +
          Config.endpoint.postgre.userrole +
          "?ProductDetails->>ProdName=in.(" +
          pfname +
          ")",
        method: "get",
      })
      .then((res) =>
        StateFunction.HandleOnChange(dispatch, {
          target: {
            name: "userrole",
            value: res,
          },
        })
      )
      .catch((err) => console.error(err));
  },

  Useractions: async (dispatch, data) => {
    const message = dispatcher
      .call({
        url:
          Config.express_host + Config.endpoint.express.Useractiveanddeactive,
        method: "patch",
        data: data,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
    return await message;
  },

  Userdefaultregions: async (dispatch, data, clientid) => {
    const message = dispatcher
      .call({
        url:
          Config.postgre_host +
          Config.endpoint.express.organizationdetails +
          "?ClientId=eq." +
          clientid,
        method: "patch",
        data: data,
      })
      .then((res) => {
        return true;
      })
      .catch((err) => {
        return err;
      });
    return await message;
  },
};
export default StateFunction;
